module.exports = "<p>\n  questions works!\n</p>\n<router-outlet></router-outlet>"